import type {
  CreateSnapQuoteLineAttachmentOutput,
  CreateSnapQuoteLineAttachmentRequest,
} from '@snap-types/actions/create-snap-quote-line-attachment';
import { QUOTE_BUILDER_SLICE_NAME } from '@ui/constants/quote-builder';
import { buildSnapQuoteUrl } from '@ui/store/api-builder/build-url';
import { injectMutation } from '@ui/store/api-builder/inject-mutation';

export const [
  createSnapQuoteLineAttachment,
  useCreateSnapQuoteLineAttachmentMutation,
] = injectMutation<
  CreateSnapQuoteLineAttachmentRequest,
  CreateSnapQuoteLineAttachmentOutput
>(
  `${QUOTE_BUILDER_SLICE_NAME}/createSnapQuoteLineAttachment`,
  ({ params, body }) => ({
    url: buildSnapQuoteUrl(
      params.siteCode,
      params.snapQuoteUuid,
      `quote-lines/${params.snapQuoteLineUuid}/attachments`,
    ),
    method: 'POST',
    body,
  }),
);
